import type { TModernColors } from '@modern/theme/modern-theme.types';
import { lightColors } from '@modern/theme/themes/colors/light-theme';

export const sewLightColors: TModernColors = {
  ...lightColors,
  accent: {
    base: '#1a6fa8',
    border: 'rgba(26, 111, 168, 0.36)',
    deep: '#1a6fa8',
    deepHover: '#155c8c',
    hover: '#145782',
    tint: 'rgba(26, 111, 168, 0.08)',
    tintStrong: 'rgba(26, 111, 168, 0.13)',
  },
  status: {
    ...lightColors.status,
    sync: {
      base: '#7a3fc4',
      border: 'rgba(122, 63, 196, 0.38)',
      tint: 'rgba(122, 63, 196, 0.08)',
      tintStrong: 'rgba(122, 63, 196, 0.12)',
    },
  },
};
